import * as React from 'react'
import { ReactElement } from 'react'
import { DocumentOverviewItemDto } from '../../../config/documentConfig'
import { DocumentCommandBarItemProps } from './DocumentCommandBar'
import { Destination } from '../../../context/AxiosContext'
import useAxios from '../../../hooks/useAxios'
import DeleteDialog from '../../Dialog/DeleteDialog'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'

export default function DeleteDocumentButton(props: DocumentCommandBarItemProps): ReactElement {
    const axios = useAxios()
    const themeClassName = useThemeClassName_unstable()

    return (
        <DeleteDialog
            className={themeClassName}
            onDelete={async setOpen => {
                await Promise.all(
                    props.selectedItems.map((item: DocumentOverviewItemDto) =>
                        axios.delete(`/items/${item.id}`, { baseURL: Destination.Documents }),
                    ),
                )
                new Set(props.selectedItems.map(item => item.stack)).forEach(stack =>
                    props.reset(props.sortOrder, stack),
                )
                setOpen(false)
            }}
        />
    )
}
